import logoFile from '../../assets/check_image.svg';

export const Check = () => {
  const checkPath = logoFile as unknown as string;

  return <img alt="visa logo" src={checkPath} />;
};
